// Papéis vindos da API (são dados: backoffice → Papéis). Uma só consulta partilhada por todas as páginas
// (filtros, distintivos, "mudar papel", página Papéis). O backend volta a verificar todas as regras.
import { useApi } from "@ecliptica/api-client/react";
import { createRoles, normalizePermissions, type RoleLabels, type Roles } from "@ecliptica/contexts-accounts";
import { activeText, useTranslation } from "@ecliptica/i18n";
import { useQuery } from "@tanstack/react-query";

export const ROLES_KEY = ["roles"] as const;

export function useRoles() {
  const api = useApi();
  return useQuery({
    queryKey: ROLES_KEY,
    queryFn: async () => {
      const res = await api.v1.admin.roles.$get();
      if (!res.ok) throw new Error(`HTTP ${res.status}`);
      const data = await res.json();
      // O mesmo conjunto que o backend usa nas regras (assignableRoles, canChangeRoleOf…).
      const set: Roles = createRoles(data.roles.map((r) => ({ ...r, permissions: normalizePermissions(r.permissions) })));
      return { ...data, set };
    },
    staleTime: 60_000,
  });
}

/** Nome visível de um papel na língua ativa (sem papéis carregados ou sem nome nessa língua, mostra a chave). */
export function useRoleLabel() {
  const { i18n } = useTranslation();
  const roles = useRoles();
  return (key: string, labels?: RoleLabels) => activeText(labels ?? roles.data?.roles.find((r) => r.key === key)?.labels, i18n.language) ?? key;
}
